import * as PIXI from 'pixi.js';
import { IAnimationDependencies, IAnimation } from 'js/bubbleCore/view/animations/types';
import { fillAnimationDependencies } from 'js/bubbleCore/view/animations/fillAnimationDependencies';

export function createShockwave(
  dependencies: Partial<IAnimationDependencies> = {},
): IAnimation<PIXI.Sprite> {
  const { spritePool, tweenMgr } = fillAnimationDependencies(dependencies);

  const root = spritePool.getInstance().props({
    texture: 'flash',
    blendMode: PIXI.BLEND_MODES.ADD,
    anchor: 0.5,
    scale: 0.8,
    alpha: 0.4,
  });

  const tween = tweenMgr.create(root.scale)
    .to({x: 1, y: 1}, 100, tweenMgr.easing.Cubic.Out, true);
  const tweenAlpha = tweenMgr.create(root)
    .to({alpha: 0}, 100, tweenMgr.easing.Sinusoidal.Out, true);

  tweenAlpha.onComplete.addOnce(() => spritePool.release(root));

  const promise = Promise.all([
    tween.asyncOnComplete,
    tweenAlpha.asyncOnComplete
  ]);

  return {
    root,
    onCompleteAsync: promise.then(),
    cancel: () => {}
  };
}